export default "__VITE_ASSET__HWguspZ1__"